import React, { FC, useState } from "react";
import { About } from "../../components/LandingPage/About";
import { Features } from "../../components/LandingPage/Features";
import { Contact } from "../../components/LandingPage/Contact";
import { Header } from "../../components/LandingPage/Header";
import { Navigationbar } from "../../components/UI/Navigationbar";
import { Footer } from "../../components/LandingPage/Footer";
import { GetStarted } from "../../components/LandingPage/GetStarted";
import { PaymentTypes } from "../../components/LandingPage/PaymentTypes";
import { FullScreenModal } from "../../components/UI/FullScreenModal";
import closeButton from "../../assets/images/close-circular-button-symbol.svg";
import { Link } from "react-router-dom";
import { AnimateSharedLayout } from "framer-motion";
import { CloudinaryContext } from "cloudinary-react";

const Home: FC<{}> = () => {
  const [showFullScreenModal, setShowFullScreenModal] = useState<boolean>(
    false
  );
  const openFullScreenModal = (): void => {
    setShowFullScreenModal(true);
  };
  const closeFullScreenModal = (): void => {
    setShowFullScreenModal(false);
  };

  return (
    <>
      {!showFullScreenModal ? (
        <CloudinaryContext cloudName="speednance">
          <Navigationbar openFullScreenModal={openFullScreenModal} />
          <Header />
          <Features />
          <About />
          <AnimateSharedLayout>
            <GetStarted />
            <PaymentTypes />
            <Contact />
            <Footer />
          </AnimateSharedLayout>
        </CloudinaryContext>
      ) : (
        <FullScreenModal>
          <div className="nav-open">
            <div className="top">
              <button onClick={closeFullScreenModal}>
                <img src={closeButton} alt="" />
              </button>
            </div>
            <div className="links">
              <ul>
                <li onClick={closeFullScreenModal}>
                  <Link to="/login">Login</Link>
                </li>
                <li onClick={closeFullScreenModal}>
                  <Link to="/register">Sign Up</Link>
                </li>
              </ul>
            </div>
          </div>
        </FullScreenModal>
      )}
    </>
  );
};

export default Home;
